import React, { useState, useRef, useEffect } from 'react';

const TruncatedTextWithTooltip = ({ text, width, fontSize, color }) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const [showFullText, setShowFullText] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      setIsOverflowed(element.scrollWidth > element.clientWidth);
    }
  }, [text, width]);

  const handleMouseEnter = () => {
    if (isOverflowed) {
      setShowFullText(true);
    }
  };

  const handleMouseLeave = () => setShowFullText(false);

  return (
    <div style={{ position: 'relative', maxWidth: '100%' }}>
      <div
        ref={textRef}
        style={{
        
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: width,
          // fontWeight: '700',
          // color: color,
          // fontFamily: 'DM Sans, sans-serif',
          // fontSize: fontSize,
          fontFamily: 'DM Sans',
          fontWeight: 500,
          fontSize: '12px',
          lineHeight: '100%',
          letterSpacing: '0%',
          cursor: isOverflowed ? 'pointer' : 'default',
          
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {text}
      </div>
      {isOverflowed && showFullText && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            background: 'white',
            border: '1px solid #ccc',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            padding: '10px',
            zIndex: 1000,
            whiteSpace: 'normal',
            maxWidth: '300px', // Adjust the max width if needed
            overflowWrap: 'break-word',
            color: 'black',
            fontSize: '12px',
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default TruncatedTextWithTooltip;